import { GA4ContextParam, GA4EventConfiguration, GA4EventDataParam, GA4UserParam } from '../models/configuration.model';
import { GA4EcommerceParam } from '../models/ecommerce.model';
import { GA4EventType } from '../models/general.model';

export class GA4ConfigurationEvents {
    private static readonly configuration: GA4EventConfiguration[] = [
        {
            name: GA4EventType.page_view,
            ecommerce: undefined,
            user: [
                GA4UserParam.im_user_status,
                GA4UserParam.im_user_type,
                GA4UserParam.im_user_client_id,
                GA4UserParam.im_user_email_sha256_1,
                GA4UserParam.im_user_email_sha256_2,
                GA4UserParam.im_user_client_type,
                GA4UserParam.im_user_id,
                GA4UserParam.im_store_id,
            ],
            context: [
                GA4ContextParam.page_location,
                GA4ContextParam.page_referrer,
                GA4ContextParam.page_title,
                GA4ContextParam.im_page_section,
                GA4ContextParam.im_page_type,
                GA4ContextParam.im_page_title,
                GA4ContextParam.im_language,
                GA4ContextParam.im_platform,
                GA4ContextParam.im_local_store_id,
                GA4ContextParam.im_store_status,
                GA4ContextParam.im_step,
                GA4ContextParam.im_user_email_sha256,
                GA4ContextParam.user_id,
                GA4ContextParam.im_physical_store,
                GA4ContextParam.im_product_section,
                GA4ContextParam.im_product_family,
                GA4ContextParam.im_product_subfamily,
                GA4ContextParam.im_user_logged,
                GA4ContextParam.im_user_loyalty,
                GA4ContextParam.im_user_quick_buy,
                GA4ContextParam.im_user_profile_status,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.app_download,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_app_store,
                GA4EventDataParam.im_location,
                GA4EventDataParam.link_text,
            ],
        },
        {
            name: GA4EventType.forgot_pass,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_type,
                GA4EventDataParam.im_action_type,
            ],
            stage: 'E',
        },
        {
            name: GA4EventType.interaction_worldwide,
            context: [
                GA4ContextParam.im_language,
                GA4ContextParam.im_local_store_id,
            ],
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_detail,
            ],
            stage: 'E',
        },
        {
            name: GA4EventType.update_pass,
            ecommerce: undefined,
            eventData: undefined,
            stage: 'E',
        },
        {
            name: GA4EventType.process_order,
            ecommerce: [
                GA4EcommerceParam.im_payment_type,
                GA4EcommerceParam.im_shipping_tier,
            ],
            eventData: [
                GA4EventDataParam.im_action_type,
            ],
        },
        {
            name: GA4EventType.view_content,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.content_id,
                GA4EventDataParam.content_type,
                GA4EventDataParam.im_location,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.view_item_list,
            ecommerce: [
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_items_number,
            ],
            eventData: [
                GA4EventDataParam.im_bundle_reference,
            ],
            stage: 'A+B',
        },
        {
            name: GA4EventType.select_item,
            ecommerce: [
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_bundle_reference,
            ],
            eventData: [
                GA4EventDataParam.im_bundle_reference,
            ],
            stage: 'A+B',
        },
        {
            name: GA4EventType.view_item,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_bundle_reference,
            ],
            eventData: [
                GA4EventDataParam.im_bundle_reference,
            ],
            stage: 'A+B',
        },
        {
            name: GA4EventType.view_promotion,
            ecommerce: [
                GA4EcommerceParam.promotion_name,
                GA4EcommerceParam.promotion_id,
                GA4EcommerceParam.location_id,
                GA4EcommerceParam.creative_slot,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.select_promotion,
            ecommerce: [
                GA4EcommerceParam.promotion_name,
                GA4EcommerceParam.promotion_id,
                GA4EcommerceParam.location_id,
                GA4EcommerceParam.creative_slot,
                GA4EcommerceParam.im_link_page_title,
                // GA4EcommerceParam.im_link_type, // Fase C
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.add_to_wishlist,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_bundle_reference,
            ],
            eventData: [],
            stage: 'A+B',
        },
        {
            name: GA4EventType.add_to_cart,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_cart_id,
                GA4EcommerceParam.im_bundle_reference,
            ],
            eventData: [
                GA4EventDataParam.im_bundle_reference,
            ],
            stage: 'A+B',
        },
        {
            name: GA4EventType.remove_from_cart,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_cart_id,
            ],
            eventData: [],
            stage: 'A+B',
        },
        {
            name: GA4EventType.view_cart,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_cart_number_items,
                GA4EcommerceParam.im_cart_id,
                GA4EcommerceParam.im_discount_type,
                GA4EcommerceParam.im_payment_gift_ticket,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.begin_checkout,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.items,
                GA4EcommerceParam.coupon,
                GA4EcommerceParam.im_discount_type,
                GA4EcommerceParam.im_cart_id,
                GA4EcommerceParam.im_payment_gift_ticket,
                GA4EcommerceParam.im_funnel_type,
                GA4EcommerceParam.im_link_text,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.add_shipping_info,
            ecommerce: [
                GA4EcommerceParam.coupon,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.im_action_type,
                GA4EcommerceParam.im_cart_id,
                GA4EcommerceParam.im_discount_type,
                GA4EcommerceParam.im_drop_point,
                GA4EcommerceParam.im_funnel_type,
                GA4EcommerceParam.im_payment_gift_ticket,
                GA4EcommerceParam.items,
                GA4EcommerceParam.shipping_tier,
                GA4EcommerceParam.value,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.add_payment_info,
            ecommerce: [
                GA4EcommerceParam.currency,
                GA4EcommerceParam.value,
                GA4EcommerceParam.coupon,
                GA4EcommerceParam.payment_type,
                GA4EcommerceParam.items,
                GA4EcommerceParam.im_discount_type,
                GA4EcommerceParam.im_cart_id,
                GA4EcommerceParam.im_gift_card_used,
                GA4EcommerceParam.im_gift_card_type,
                GA4EcommerceParam.im_gift_card_value,
                GA4EcommerceParam.im_payment_gift_ticket,
                GA4EcommerceParam.im_funnel_type,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.purchase,
            ecommerce: [
                GA4EcommerceParam.value,
                GA4EcommerceParam.currency,
                GA4EcommerceParam.transaction_id,
                GA4EcommerceParam.tax,
                GA4EcommerceParam.items,
                GA4EcommerceParam.shipping,
                GA4EcommerceParam.coupon,
                GA4EcommerceParam.im_shipping_tier,
                GA4EcommerceParam.im_discount_type,
                GA4EcommerceParam.im_drop_point,
                GA4EcommerceParam.im_payment_type,
                GA4EcommerceParam.im_gift_card_used,
                GA4EcommerceParam.im_gift_card_type,
                GA4EcommerceParam.im_gift_card_value,
                GA4EcommerceParam.im_payment_gift_ticket,
                GA4EcommerceParam.im_funnel_type,
            ],
            eventData: undefined,
            stage: 'A+B',
        },
        {
            name: GA4EventType.search,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.search_term,
                GA4EventDataParam.im_items_number,
                GA4EventDataParam.im_type,
                GA4EventDataParam.im_event_data_cf,
            ],
            stage: 'C',
        },
        {
            name: GA4EventType.generate_lead,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_type,
                GA4EventDataParam.im_location,
                GA4EventDataParam.im_event_data_cf,
            ],
            stage: 'C',
        },
        {
            name: GA4EventType.login,
            user: [
                GA4UserParam.im_user_status,
                GA4UserParam.im_user_type,
                GA4UserParam.im_user_client_id,
                GA4UserParam.im_user_email_sha256_1,
                GA4UserParam.im_user_email_sha256_2,
                GA4UserParam.im_user_client_type,
                GA4UserParam.im_user_id,
                GA4UserParam.im_store_id,
            ],
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.method,
                GA4EventDataParam.im_event_data_cf,
            ],
            stage: 'C',
        },
        {
            name: GA4EventType.sign_up,
            user: [
                GA4UserParam.im_user_status,
                GA4UserParam.im_user_type,
                GA4UserParam.im_user_client_id,
                GA4UserParam.im_user_email_sha256_1,
                GA4UserParam.im_user_email_sha256_2,
                GA4UserParam.im_user_client_type,
                GA4UserParam.im_user_id,
                GA4UserParam.im_store_id,
            ],
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.method,
                GA4EventDataParam.im_event_data_cf,
            ],
            stage: 'C',
        },
        {
            name: GA4EventType.begin_search,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.im_location,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.error_custom,
            ecommerce: undefined,
            eventData: [
                // GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.im_type,
                GA4EventDataParam.im_location,
                GA4EventDataParam.im_event_name,
                GA4EventDataParam.im_detail,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.select_content,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.content_id,
                GA4EventDataParam.content_type,
                GA4EventDataParam.content_value,
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_bundle_reference,
                GA4EventDataParam.im_carousel_index,
                GA4EventDataParam.im_category_cross_type,
                GA4EventDataParam.im_detail,
                GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.im_link_category,
                GA4EventDataParam.im_link_page_title,
                GA4EventDataParam.im_link_type,
                GA4EventDataParam.im_location,
                GA4EventDataParam.im_photo_reference,
                GA4EventDataParam.im_photo_type,
                GA4EventDataParam.im_product_color,
                GA4EventDataParam.im_product_size,
                GA4EventDataParam.im_shipping_tier,
                GA4EventDataParam.im_store_zip_code,
                GA4EventDataParam.im_type,
                GA4EventDataParam.item_id,
                GA4EventDataParam.link_text,
                GA4EventDataParam.link_url,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.size_recommender_open,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_item_id,
                GA4EventDataParam.size_recommender_name,
            ],
        },
        {
            name: GA4EventType.form_start,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.form_name,
                GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.content_type,
                GA4EventDataParam.im_location,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.interaction_filter,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_type,
                GA4EventDataParam.im_detail,
                // GA4EventDataParam.im_index, // Se decide no implementar por complejidad excesiva
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.change_view_item_list,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_items_number,
                GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.im_category_view_type,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.interaction_chat,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_event_data_cf,
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_location,
                GA4EventDataParam.link_text,
                GA4EventDataParam.im_link_type,
            ],
            stage: 'D',
        },
        {
            name: GA4EventType.change_shipping_address,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_transaction_id,
                GA4EventDataParam.im_type,
            ],
            stage: 'E',
        },
        {
            name: GA4EventType.cancel_order,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_transaction_id,
                GA4EventDataParam.im_order_state,
            ],
            stage: 'E',
        },
        {
            name: GA4EventType.process_order,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
            ],
            stage: 'E',
        },
        {
            name: GA4EventType.file_download,
            ecommerce: undefined,
            eventData: [
                GA4EventDataParam.im_action_type,
                GA4EventDataParam.im_detail,
            ],
            stage: 'E',
        },
    ];

    public getConfigurationCodeEvent(name: GA4EventType): GA4EventConfiguration {
        return GA4ConfigurationEvents.configuration.filter((c) => c.name === name)[0];
    }
}
